var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Cell",class:{
    'sortable' : _vm.sort
  },on:{"click":_vm.toggle}},[_vm._t("default"),_c('span',{staticClass:"ml10"},[(_vm.sort)?[_c('i',{class:{
          'invisible' : _vm.value.by !== _vm.sort,
          'hidden' : _vm.value.by === _vm.sort,
          'fas fa-sort' : true
        }}),_c('i',{class:( _obj = {
          'hidden' :
              _vm.value.by !== _vm.sort ||
              _vm.value.order !== 'asc'
        }, _obj[ _vm.ascIcon ] = true, _obj )}),_c('i',{class:( _obj$1 = {
          'hidden' :
              _vm.value.by !== _vm.sort ||
              _vm.value.order !== 'desc'
        }, _obj$1[ _vm.descIcon ] = true, _obj$1 )})]:_vm._e()],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }